

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    
    <span class="panel-title" *ngIf="!hcpClassid">{{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="hcpClassid">{{'app.editTile' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center"  *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">

          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (name.dirty || name.touched || f.submitted)  && name.valid, 'has-error' : (name.dirty || name.touched || f.submitted)  && name.invalid}">
              <label class="control-label">{{'app.name' | translate}} </label>
              <input type="text"
                     name="name"
                     [(ngModel)]="hcpclass.name"
                     #name="ngModel" placeholder="{{'app.name' | translate}}"
                     required="required"
                     class="form-control" />
              <div *ngIf="(name.dirty || name.touched || f.submitted)  && name.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (visitsPerPlan.dirty || visitsPerPlan.touched || f.submitted)  && visitsPerPlan.valid, 'has-error' : (visitsPerPlan.dirty || visitsPerPlan.touched || f.submitted)  && visitsPerPlan.invalid}">
              <label class="control-label">{{'Visits Per Month' | translate}} </label>
              <input type="number"
                     name="visitsPerPlan"
                     [(ngModel)]="hcpclass.visitsPerPlan"
                     #visitsPerPlan="ngModel"
                     placeholder="{{'Visits Per Month' | translate}}"
                     required="required"
                     class="form-control" />
              <div *ngIf="(visitsPerPlan.dirty || visitsPerPlan.touched || f.submitted)  && visitsPerPlan.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="businessUnits&&businessUnits.length>0">
            <div [ngClass]="{'has-success': (bu.dirty || bu.touched || f.submitted)  && bu.valid, 'has-error' : (bu.dirty || bu.touched || f.submitted)  && bu.invalid}">
              <label class="control-label">{{'Business Units' |translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="businessUnits" 
                            styleClass="wid100"
                            [placeholder]="'Business Units'"
                            emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                            showClear="true"
                            name="bu"
                            #bu="ngModel"
                            [(ngModel)]="hcpclass.businessUnit"
                            baseZIndex="9999"
                            [filter]="true" optionLabel="name"
                            
                            required>
                </p-dropdown>
              </span>
              <div *ngIf="(bu.dirty || bu.touched || f.submitted)  && bu.invalid" class="jquery-validate-error help-block">
                {{'Type is required' | translate}}
              </div>
            </div>

          </div>
        </div>
        <div class="row padding-sm-vr">
          <div class="col-sm-4" *ngFor="let month of months; let i = index">
            <div>
              <label class="control-label">{{month.name}} </label>
              <input type="number"
                     name="visitsPerPlan{{i}}"
                     [ngModel]="getMonthData(month.id)"
                     (ngModelChange)="setMonthData(month.id, $event)"
                     #visitsPerPlan="ngModel"
                     placeholder="{{'hcpClass.visitsPerPlan' | translate}}"
                     class="form-control" />
            </div>
          </div>
        </div>
          <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
            <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
            <button class="btn  btn-save" type="submit" *ngIf="!hcpClassid">{{'app.create' | translate}}</button>
            <button class="btn  btn-save" type="submit" *ngIf="hcpClassid">{{'app.save' | translate}}</button>
          </div>
      </form>
    </div>
  </div>
</div>




<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




